import { render, staticRenderFns } from "./articleFilter.vue?vue&type=template&id=6f2353d3&scoped=true&"
import script from "./articleFilter.vue?vue&type=script&lang=js&"
export * from "./articleFilter.vue?vue&type=script&lang=js&"
import style0 from "./articleFilter.vue?vue&type=style&index=0&id=6f2353d3&prod&scoped=true&lang=scss&"
import style1 from "./articleFilter.vue?vue&type=style&index=1&id=6f2353d3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2353d3",
  null
  
)

export default component.exports